import { getChannelConf, refreshChannelConf, autoChannelConf } from '@/api/channel'
import Store from 'store'

const actions = {
    getChannelConf({ commit }) {
        return getChannelConf().then(data => {
            commit('SET_CHANNEL_CONF', data)
            return Promise.resolve()
        })
    },
    refreshChannelConf(payload) {
        return refreshChannelConf(payload).then(() => {
            return Promise.resolve()
        })
    },
    autoChannelConf(payload) {
        return autoChannelConf(payload).then(() => {
            return Promise.resolve()
        })
    }
}

const mutations = {
    'SET_CHANNEL_CONF' (state, payload) {
        let channelConf = {}
        try {
            channelConf = {
                isShowTitle: !(payload.productAppType && payload.productAppType == '1'),
                isShowMarket: !!(payload.supermarketView && payload.supermarketView == 1),
                isShowLogout: !!(payload.canQuit && payload.canQuit == 1),
                isShowDownload: !!(payload.dumiaoDown && payload.dumiaoDown == 1),
                skin: payload.cssTyle || "",
                client: payload.productAppType == '1' ? "app" : "h5",
                locale: ["idmiao635"].indexOf(payload.partner) === -1 ? "default" : "meitu",
                creditFlow: payload.canCreditCard == 0 ? "IRR36" : "APR",
                contractDescs: payload.contractDescs || []
            }
        } catch (exp) {
            // empty
        }
        state.conf = channelConf
        Store.set('dm_channel_conf_' + payload.partner, channelConf)
    },
    'RESET_CHANNEL_CONF' (state) {
        state.conf = {}
    }
}

const state = {
    conf: {}
}
export default {
    state,
    mutations,
    actions
}
